export const RECIPE_SECTORS = ["Cocina", "Barra"];

export function normalizeRecipeSectors(value) {
  const values = Array.isArray(value)
    ? value
    : typeof value === "string"
      ? value.split(",")
      : [];

  return RECIPE_SECTORS.filter((sector) =>
    values.some(
      (item) =>
        String(item).trim().toLocaleLowerCase("es-AR") ===
        sector.toLocaleLowerCase("es-AR")
    )
  );
}

export function formatRecipeSectors(value) {
  const sectors = normalizeRecipeSectors(value);
  return sectors.length ? sectors.join(" y ") : "-";
}
